import React, { ComponentType, PropsWithChildren } from "react";

export type ProviderComponent = ComponentType<PropsWithChildren<any>>; // eslint-disable-line @typescript-eslint/no-explicit-any

export interface ProviderWithProps {
  provider: ProviderComponent;
  props?: Record<string, any>; // eslint-disable-line @typescript-eslint/no-explicit-any
}

export interface GroupProviderProps {
  providers: (ProviderComponent | ProviderWithProps)[];
  children: React.ReactNode;
}

export const GroupProvider: React.FC<GroupProviderProps> = ({
  providers,
  children,
}) => {
  return providers.reduceRight((acc, CurrentProvider) => {
    if ("provider" in CurrentProvider) {
      const { provider: Provider, props = {} } =
        CurrentProvider as ProviderWithProps;
      return <Provider {...props}>{acc}</Provider>;
    }
    const Provider = CurrentProvider;
    return <Provider>{acc}</Provider>;
  }, <>{children}</>);
};
